import { differenceInYears, isAfter } from 'date-fns';
import * as z from 'zod/v4';

export const loginSchema = z.object({
	name: z.string(),
	email: z.email({ error: 'Email tidak valid' })
});

export type LoginSchema = z.output<typeof loginSchema>;

export const mainSchema = z.object({
	name: z.string(),
	company_id: z
		.number()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	business_area_id: z
		.number()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	qualification_id: z
		.number()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	type_cooperations: z
		.array(z.number())
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}

			if (val?.length === 0) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	website: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (val && val.length > 100) {
				ctx.addIssue({
					code: 'custom',
					message: 'Maksimal 100 Karakter'
				});
			}
		}),
	phone_number: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}

			if (val && Number.isNaN(+val)) {
				ctx.addIssue({
					code: 'custom',
					message: 'Hanya dapat masukkan angka'
				});
			}

			if (val && val.length < 12) {
				ctx.addIssue({
					code: 'custom',
					message: 'Minimal 12 Karakter'
				});
			}

			if (val && val.length > 13) {
				ctx.addIssue({
					code: 'custom',
					message: 'Maksimal 13 Karakter'
				});
			}
		}),
	address: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}

			if (val && val.length > 255) {
				ctx.addIssue({
					code: 'custom',
					message: 'Maks. 255 Karakter'
				});
			}
		}),
	province_id: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	city_id: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	district_id: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	village_id: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	postal_code: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (val && Number.isNaN(+val)) {
				ctx.addIssue({
					code: 'custom',
					message: 'Hanya dapat masukkan angka'
				});
			}

			if (val && val.length !== 5) {
				ctx.addIssue({
					code: 'custom',
					message: 'Masukkan 5 karakter'
				});
			}
		}),

	npwp: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}

			if (val && Number.isNaN(+val)) {
				ctx.addIssue({
					code: 'custom',
					message: 'Hanya dapat masukkan angka'
				});
			}

			if (val && val.length < 15) {
				ctx.addIssue({
					code: 'custom',
					message: 'Masukkan 15 karakter'
				});
			}

			if (val && val.length > 16) {
				ctx.addIssue({
					code: 'custom',
					message: 'Maksimal 16 karakter'
				});
			}
		}),
	npwp_file_name: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	npwp_name: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}

			if (val && val.length > 100) {
				ctx.addIssue({
					code: 'custom',
					message: 'Maks.100 karakter'
				});
			}
		}),
	npwp_address: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}

			if (val && val.length > 255) {
				ctx.addIssue({
					code: 'custom',
					message: 'Maks. 255 Karakter'
				});
			}
		}),

	pic_name: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}

			if (val && val.length > 100) {
				ctx.addIssue({
					code: 'custom',
					message: 'Maks.100 karakter'
				});
			}
		}),
	pic_email: z
		.email({ error: 'Format email tidak sesuai' })
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	pic_phone_number: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}

			if (val && Number.isNaN(+val)) {
				ctx.addIssue({
					code: 'custom',
					message: 'Hanya dapat masukkan angka'
				});
			}

			if (val && val.length < 12) {
				ctx.addIssue({
					code: 'custom',
					message: 'Minimal 12 Karakter'
				});
			}

			if (val && val.length > 13) {
				ctx.addIssue({
					code: 'custom',
					message: 'Maksimal 13 Karakter'
				});
			}
		}),
	pic_nik: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}

			if (val && Number.isNaN(+val)) {
				ctx.addIssue({
					code: 'custom',
					message: 'Hanya dapat masukkan angka'
				});
			}

			if (val && val.length < 16) {
				ctx.addIssue({
					code: 'custom',
					message: 'Minimal 16 Karakter'
				});
			}

			if (val && val.length > 20) {
				ctx.addIssue({
					code: 'custom',
					message: 'Maksimal 20 Karakter'
				});
			}
		})
});
export type MainSchema = z.output<typeof mainSchema>;

export const bankDataSchema = z.object({
	bankId: z.coerce
		.number()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	accountName: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	accountNumber: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}

			if (val && val?.length < 5) {
				ctx.addIssue({
					code: 'custom',
					message: 'Minimal 5 Karakter'
				});
			}

			if (val && val?.length > 20) {
				ctx.addIssue({
					code: 'custom',
					message: 'Maksimal 20 Karakter'
				});
			}

			if (val && Number.isNaN(+val)) {
				ctx.addIssue({
					code: 'custom',
					message: 'Hanya dapat masukkan angka'
				});
			}
		}),
	image: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		})
});
export type BankDataSchema = z.output<typeof bankDataSchema>;

export const segmentationDataSchema = z.object({
	businessFieldId: z.coerce
		.number()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	subBusinessFieldId: z.coerce
		.number()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		})
});
export type SegmentationDataSchema = z.output<typeof segmentationDataSchema>;

export const picDataSchema = z.object({
	name: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}

			if (val && val.length > 100) {
				ctx.addIssue({
					code: 'custom',
					message: 'Maks.100 karakter'
				});
			}
		}),
	phoneNumber: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}

			if (val && Number.isNaN(+val)) {
				ctx.addIssue({
					code: 'custom',
					message: 'Hanya dapat masukkan angka'
				});
			}

			if (val && val.length < 12) {
				ctx.addIssue({
					code: 'custom',
					message: 'Minimal 12 Karakter'
				});
			}

			if (val && val.length > 13) {
				ctx.addIssue({
					code: 'custom',
					message: 'Maksimal 13 Karakter'
				});
			}
		}),
	occupationId: z
		.number()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	positionId: z
		.number()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	nik: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}

			if (val && Number.isNaN(+val)) {
				ctx.addIssue({
					code: 'custom',
					message: 'Hanya dapat masukkan angka'
				});
			}

			if (val && val.length < 16) {
				ctx.addIssue({
					code: 'custom',
					message: 'Minimal 16 Karakter'
				});
			}

			if (val && val.length > 20) {
				ctx.addIssue({
					code: 'custom',
					message: 'Maksimal 20 Karakter'
				});
			}
		}),
	email: z
		.email({ error: 'Email tidak valid' })
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	birthDate: z.iso
		.date()
		.or(z.date())
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}

			if (val && differenceInYears(new Date(), val) < 18) {
				ctx.addIssue({
					code: 'custom',
					message: 'Usia harus lebih dari 18 Tahun'
				});
			}
		}),
	selfieFile: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	ktpFile: z
		.string()
		.nullable()
		.superRefine((val, ctx) => {
			if (!val) {
				ctx.addIssue({
					code: 'custom',
					message: 'Wajib diisi'
				});
			}
		}),
	position: z.string().optional()
});
export type PicDataSchema = z.output<typeof picDataSchema>;

export const documentDataSchema = z
	.object({
		documentId: z.enum([
			'D001',
			'D002',
			'D003',
			'D004',
			'D005',
			'D006',
			'D007',
			'D008',
			'D009',
			'D0010'
		]),
		value: z.string().optional(),
		files: z.array(
			z.object({
				id: z.number().optional(),
				fileName: z.string(),
				documentNumber: z.string().nullable(),
				startDate: z.iso.date().or(z.date()).nullable(),
				endDate: z.iso.date().or(z.date()).nullable()
			})
		)
	})
	.superRefine((data, ctx) => {
		if (data.documentId !== 'D005') {
			data.files.forEach((file, index) => {
				if (!file.documentNumber || file.documentNumber.trim() === '') {
					ctx.addIssue({
						code: 'custom',
						message: 'Wajib Diisi',
						path: ['files', index, 'documentNumber']
					});
				}

				if (file.documentNumber && file.documentNumber.length > 30) {
					ctx.addIssue({
						code: 'custom',
						message: 'Maksimal 30 karakter',
						path: ['files', index, 'documentNumber']
					});
				}

				if (!file.startDate) {
					ctx.addIssue({
						code: 'custom',
						message: 'Wajib Diisi',
						path: ['files', index, 'startDate']
					});
				}

				if (!file.endDate) {
					ctx.addIssue({
						code: 'custom',
						message: 'Wajib Diisi',
						path: ['files', index, 'endDate']
					});
				}

				if (file.startDate && isAfter(file.startDate, new Date())) {
					ctx.addIssue({
						code: 'custom',
						message: 'Tanggal terbit tidak boleh kurang dari hari ini',
						path: ['files', index, 'startDate']
					});
				}

				if (file.startDate && file.endDate) {
					const start = new Date(file.startDate);
					const end = new Date(file.endDate);

					if (end < start) {
						ctx.addIssue({
							code: 'custom',
							message: 'Tanggal akhir tidak boleh kurang dari tanggal mulai',
							path: ['files', index, 'endDate']
						});
					}
				}
			});
		}
	});
export type DocumentDataSchema = z.output<typeof documentDataSchema>;

export const approveDocumentSchema = z
	.object({
		status: z.enum(['approved', 'revised']),
		remarks: z.string().nullish(),
		option: z.string().nullish()
	})
	.superRefine((data, ctx) => {
		if (data.status === 'revised' && !data.option) {
			ctx.addIssue({
				code: 'custom',
				message: 'Wajib diisi',
				path: ['option']
			});
		}
		if (data.option === 'other' && !data.remarks) {
			ctx.addIssue({
				code: 'custom',
				message: 'Wajib Diisi',
				path: ['remarks']
			});
		}

		if (data.option === 'other' && data.remarks && data.remarks?.length > 255) {
			ctx.addIssue({
				code: 'custom',
				message: 'Maks.255 karakter',
				path: ['remarks']
			});
		}
	});
export type ApproveDocumentSchema = z.output<typeof approveDocumentSchema>;
